import { MessageCircle, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface FloatingChatBubbleProps {
  isOpen: boolean;
  onClick: () => void;
}

export const FloatingChatBubble = ({ isOpen, onClick }: FloatingChatBubbleProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "fixed bottom-5 right-5 z-50",
        "w-16 h-16 rounded-full",
        "bg-background text-primary border-2 border-primary",
        "shadow-xl hover:shadow-2xl",
        "flex items-center justify-center",
        "transition-all duration-300 ease-out",
        "hover:scale-110 hover:bg-primary hover:text-primary-foreground",
        "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      )}
      aria-label={isOpen ? "Cerrar chat" : "Abrir chat con Florencia"}
    >
      <div className={cn(
        "transition-transform duration-300",
        isOpen ? "rotate-90" : "rotate-0"
      )}>
        {isOpen ? (
          <X className="w-7 h-7" />
        ) : (
          <MessageCircle className="w-7 h-7" />
        )}
      </div>
    </button>
  );
};
